<template>
  <alzata-odata-table
    ref="grid"
    clickable
    title="Veterans"
    endpoint="/api/v1/profiles"
    :columns="[
      {
        id: 'DisplayName',
        label: 'Name',
        sortable: true,
      },
      {
        id: 'Email',
        label: 'Email',
        sortable: true,
      },
      {
        id: 'DogName',
        label: 'Dog',
        sortable: true,
      },
    ]"
    :actions="[
      {
        id: 'edit',
        icon: (item) => 'far/pencil',
        tooltip: 'Edit',
        default: true,
        click: show,
      },
      {
        id: 'assign-dog',
        icon: (item) => 'fas/dog',
        tooltip: 'Assign a Dog',
        default: false,
        click: assignDog,
      },
      {
        id: 'deleteVeteran',
        icon: (item) => 'far/trash',
        tooltip: 'Delete',
        default: true,
        click: showDeleteVeteran,
      },
    ]"
    :filters="['IsVeteran eq true']"
  >
    <template v-slot:buttons>
      <button
        type="button"
        class="btn btn-primary btn-sm ms-1"
        @click="show({})"
      >
        <alzata-icon icon="far/plus-circle" /> Add a Veteran
      </button>
    </template>
  </alzata-odata-table>
  <edit-veteran-dialog ref="editDialog" @save="save" />
  <assign-dog-dialog
    ref="assignDogDialog"
    @saveDogAssignment="saveDogAssignment"
  />
  <delete-veteran-dialog ref="deleteVeteranDialog" @deleteVeteran="deleteVeteran"/>
</template>

<script>
import EditVeteranDialog from "@/dialogs/EditVeteranDialog.vue";
import AssignDogDialog from "@/dialogs/AssignDogDialog.vue";
import DeleteVeteranDialog from "@/dialogs/DeleteVeteranDialog.vue";

export default {
  name: "VeteranList",
  components: {
    EditVeteranDialog,
    AssignDogDialog,
    DeleteVeteranDialog
  },
  methods: {
    show(veteran) {
      this.$refs.editDialog.show(veteran);
    },
    assignDog(veteran) {
      this.$refs.assignDogDialog.show(veteran);
    },
    async saveDogAssignment(veteranDogAssignment) {
      console.log("saving dog assignment");
      console.log(veteranDogAssignment);
      const body = {
        userId: veteranDogAssignment.userId,
        dogId: veteranDogAssignment.dogId,
      };
      const res = await this.apiClient.postJson("/api/v1/profiles/assign-dog", {
        body,
      });
      if (!res.success) {
        alert("error saving veteran");
        return;
      }
      this.$refs.grid.reload();
      this.$refs.assignDogDialog.hide();
    },
    async save(veteran) {
      const body = {
        firstName: veteran.firstName,
        lastName: veteran.lastName,
        email: veteran.email,
        phoneNumber: veteran.phoneNumber,
        password: veteran.password,
        pushToken: veteran.pushToken,
        dogId: veteran.dogId,
        isVeteran: true,
        isAdmin: false,
      };

      if (veteran.userId) {
        const res = await this.apiClient.putJson(
          `/api/v1/profiles/${veteran.userId}`,
          {
            body,
          }
        );

        if (!res.success) {
          alert("error saving veteran");
          return;
        }
      } else {
        const res = await this.apiClient.postJson(
          "/api/v1/profiles/create-veteran",
          {
            body,
          }
        );
        if (!res.success) {
          alert("error saving veteran");
          return;
        }
      }

      this.$refs.grid.reload();
      this.$refs.editDialog.hideEditVeteran();
    },
    showDeleteVeteran(veteran) {
      this.$refs.deleteVeteranDialog.show(veteran);
    },
    async deleteVeteran(veteran) {
      await this.apiClient.doDelete(`/api/v1/profiles/delete-veteran/${veteran.userId}`, { });
      this.$refs.deleteVeteranDialog.hide();
      this.$refs.grid.reload();
    },
  },
};
</script>
